import React from 'react'
import DropdownSelect from '../../../../../../common/inputs/dropdownSelect/DropdownSelect'
import { UsageTypeOption } from '../../../../../../../@types/dropdown-types'
import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'

const UsageType: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  insertionData,
  onChange,
  screenName,
  wrapperClassName = 'grid-item one-whole',
}) => {
  return (
    <div className={wrapperClassName}>
      <DropdownSelect
        id='usage-type'
        name='usageType'
        label='wizard.screen.otherFacilities.usageType'
        options={{
          translationKeyGroup: 'wizard.screen.otherFacilities.usageTypeOptions',
          options: Object.keys(UsageTypeOption),
        }}
        value={insertionData.usageType ?? UsageTypeOption.TRADE}
        onChange={(value) => onChange({ screen: screenName, property: 'usageType' }, value.value!)}
      />
    </div>
  )
}

export default UsageType
